// extracted by mini-css-extract-plugin
var _1 = "ExpectedGainsChartStyle-module__axisYLabel___DUhYa";
var _2 = "ExpectedGainsChartStyle-module__title___jjmN9";
var _3 = "ExpectedGainsChartStyle-module__wrapper___UILqE";
export { _1 as "axisYLabel", _2 as "title", _3 as "wrapper" }
